/*jshint esversion: 6 */
import React from 'react';

class DragHandle extends React.Component {
    render() {

        return (!this.props.item.post_ts) ? (
            <div className="drag-handle">
                    <div className="icon-wrapper">
                        <i className="fa fa-ellipsis-v"></i>
                        <i className="fa fa-ellipsis-v"></i>
                    </div>
                </div>
        ) : null;

    }

};

export default DragHandle;
